import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import SidebarLayout from '../../dashboard/components/SidebarLayout';
import {AppTitle} from '../../../Presentation/components/ui/Typography';
import Card from '../../../Presentation/components/ui/Card';
import Tabs from '../../../Presentation/components/ui/Tabs';
import InventoryOverviewPage from '../components/InventoryOverviewPage';
import InventoryMovementPage from '../components/InventoryMovementPage';
import SerialsTrackingTab from '../components/SerialsTrackingTab';
import {Package, History, Hash} from 'lucide-react';

type ActiveTab = 'overview' | 'movements' | 'serials';

const InventoryPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') as ActiveTab | null;
  const serialParam = searchParams.get('serial');

  const [defaultTab, setDefaultTab] = useState<ActiveTab>('overview');

  useEffect(() => {
    if (tabParam && ['overview', 'movements', 'serials'].includes(tabParam)) {
      setDefaultTab(tabParam);
    }
  }, [tabParam]);

  const tabItems = [
    {key: 'overview' as const, label: 'نظرة عامة', description: 'نظرة شاملة على المخزون', icon: <Package className="w-5 h-5" />, content: <div className="p-6"><InventoryOverviewPage /></div>},
    {key: 'movements' as const, label: 'حركة المخزون', description: 'سجل الحركات والإدخالات', icon: <History className="w-5 h-5" />, content: <div className="p-6"><InventoryMovementPage initialSerialFilter={serialParam ?? undefined} /></div>},
    {key: 'serials' as const, label: 'تتبع الأرقام التسلسلية', description: 'إدارة الأرقام التسلسلية', icon: <Hash className="w-5 h-5" />, content: <div className="p-6"><SerialsTrackingTab /></div>}
  ];

  return (
    <SidebarLayout>
      <div className="space-y-6">
        <div>
          <AppTitle className="text-2xl font-bold text-gray-900">المخزون</AppTitle>
          <p className="text-gray-600 mt-1">نظرة عامة على المخزون والحركات والأرقام التسلسلية</p>
        </div>

        <Card className="p-0 overflow-hidden shadow-sm">
          <Tabs
            items={tabItems}
            defaultActiveKey={defaultTab}
            variant="modern"
            className="flex-1"
          />
        </Card>
      </div>
    </SidebarLayout>
  );
};

export default InventoryPage;
